import React from 'react';

const Login = () => {
    return (
        <div>
            <h2>Please login</h2>
        </div>
    );
};

export default Login;